// The prices the organization is charged, as they stand today: the six published prices, each the
// organization's own where one was negotiated for it, with the day it ends and what follows, the
// delivery allowance, and the basis its video storage is billed on.
//
// **Every member reads it** — not `tenancy.billing.manage` alone like the wallet next door
// (`surfaces/app/routes/prices.rs`): an estimate is shown to whoever starts what it prices. Every
// price is in micro-cents excluding tax, since a negotiated one need not be a whole cent; `0` is
// offered. A platform billed by contract answers `sells_credits: false` and no price.

import { api } from '../client'
import type { components } from '../schema'

export type OrgPricesView = components['schemas']['OrgPricesView']
export type OrgPriceEntry = components['schemas']['OrgPriceEntry']
export type OrgPriceChange = components['schemas']['OrgPriceChange']
export type OrgPriceKey = components['schemas']['OrgPriceKey']
export type OrgVideoStorageBasis = components['schemas']['OrgVideoStorageBasis']
export type VideoStorageBasis = components['schemas']['VideoStorageBasis']

/** The organization's prices today. */
export function readPrices(signal?: AbortSignal): Promise<OrgPricesView> {
  return api.get<OrgPricesView>('/orgs/current/prices', undefined, signal)
}
